import React from 'react'
import { TextStyle, TouchableOpacity, View, ViewStyle } from 'react-native'
import { color } from '../../theme'
import { iconClose } from '../../assets'
import { Label } from '../label'
import { Medallion } from '../medallion'
import { RecallWheel } from '../recall-wheel'
import { SvgIcon } from '../svg-icon'
import { Text } from '../text'
import { Dialog } from '@mui/material'
import { DateTime } from 'luxon'
import { Medal } from '../medal'
import { observer } from 'mobx-react-lite'
import { useMediaQuery } from '@mui/material'

interface CertificationModalProps {
  visible: boolean
  onClose: () => void
  title: string
  level: string
  earned: string
  recall: number | null | undefined
  criteria: string
  medal?: boolean
}
export const CertificationModal = observer((props: CertificationModalProps) => {
  const { medal, criteria, visible, level, onClose, recall, earned, title } = props

  const earnedDate = DateTime.fromISO(earned).toLocaleString(DateTime.DATE_MED)

  // @ts-ignore
  const levelColor = color[level?.toLowerCase()]

  const isMobile = !useMediaQuery('(min-width:800px)')

  return (
    <Dialog aria-labelledby="confirmation-dialog-title" open={visible} style={ROOT}>
      <View style={{ ...CONTAINER, width: isMobile ? '' : 350 }}>
        <TouchableOpacity
          // @ts-ignore
          dataSet={{ qat: 'close_btn' }}
          onPress={onClose}
          style={CLOSE_BUTTON}
        >
          <SvgIcon src={iconClose} color={color.black} size={24} />
        </TouchableOpacity>
        {medal ? (
          <Medal style={{ alignSelf: 'center' }} level={level} recall={recall} size={74} />
        ) : (
          <Medallion style={{ top: -48 }} type={level} recall={recall} scale={0.74} />
        )}
        <View style={CONTENT}>
          <Text style={TITLE} variant="headline" text={title} />
          <Label
            labelColor={{
              background: medal ? color.white : `${levelColor}20`,
              text: String(levelColor),
            }}
            style={{ alignSelf: 'center', marginBottom: 20 }}
            icon={
              medal ? null : (
                <svg
                  width="15"
                  height="13"
                  viewBox="0 0 15 13"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M14.916 6.5L13.3633 4.77286L13.5797 2.48857L11.2824 1.98095L10.0797 0L7.91602 0.90381L5.75238 0L4.54965 1.97476L2.25238 2.47619L2.46874 4.76667L0.916016 6.5L2.46874 8.22714L2.25238 10.5176L4.54965 11.0252L5.75238 13L7.91602 12.09L10.0797 12.9938L11.2824 11.019L13.5797 10.5114L13.3633 8.22714L14.916 6.5ZM6.24874 8.98238L4.7342 7.49667C4.48602 7.25524 4.48602 6.86524 4.7342 6.62381L4.77874 6.58048C5.02692 6.33905 5.4342 6.33905 5.68238 6.58048L6.70692 7.58333L9.9842 4.38905C10.2324 4.14762 10.6397 4.14762 10.8878 4.38905L10.9324 4.43238C11.1806 4.67381 11.1806 5.06381 10.9324 5.30524L7.16511 8.98238C6.9042 9.22381 6.50329 9.22381 6.24874 8.98238Z"
                    fill={String(levelColor)}
                  />
                </svg>
              )
            }
            labelTx={
              medal ? `Quiz.${level.toLowerCase()}Medal` : `Certifications.${level?.toLowerCase()}`
            }
          />
          <View style={{ marginBottom: 30 }}>
            <Text
              style={{ marginBottom: 4, color: color.shade70, textAlign: 'center' }}
              variant="body1Emphasized"
              tx="Certifications.earned"
            />
            <Text
              style={{ textAlign: 'center', color: color.shade70 }}
              variant="body1"
              text={earnedDate}
            />
          </View>
          <View style={{ marginBottom: 40 }}>
            <Text
              style={{ marginBottom: 4, textAlign: 'center', color: color.shade70 }}
              variant="body1Emphasized"
              tx="Certifications.qualification"
            />
            <Text
              style={{ width: 230, textAlign: 'center', color: color.shade70 }}
              variant="body1"
              text={criteria}
            />
          </View>
          {recall && (
            <Text
              style={{ textAlign: 'center', color: color.shade70, marginBottom: 20 }}
              variant="body1Emphasized"
              tx="Profile.recall"
            />
          )}
          {recall && (
            <RecallWheel
              useDefaultFill
              textColor={levelColor}
              variant="large"
              showPercentage
              value={recall}
              circleColour={levelColor}
            />
          )}
        </View>
      </View>
    </Dialog>
  )
})

/**
 * Styling
 */
const ROOT: React.CSSProperties = {
  flex: 1,
  backgroundColor: color.shade20,
  flexDirection: 'column',
  justifyContent: 'center',
}
const CONTAINER: ViewStyle = {
  padding: 20,
  height: 501,
  paddingTop: 10,
  borderRadius: 20,
  margin: 20,
  backgroundColor: color.white,
  borderBottomLeftRadius: 20,
  borderBottomRightRadius: 20,
}
const TITLE: TextStyle = {
  alignSelf: 'center',
  color: color.black,
  textAlign: 'center',
  marginBottom: 20,
}
const CLOSE_BUTTON: ViewStyle = {
  borderRadius: 100,
  width: 42,
  height: 42,
  backgroundColor: color.shade04,
  justifyContent: 'center',
  alignItems: 'center',
  right: 0,
  position: 'absolute',
  top: 0,
}
const CONTENT: ViewStyle = {
  top: 12,
  flex: 1,
  justifyContent: 'space-evenly',
  alignItems: 'center',
}
